import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CustomLoading from "../CustomLoader";
import { getFMPdata } from "../../../store/actions";
import { fmp_columns } from "../../forms/content";
import { Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { FormatCurrency } from "../currencyFormatter";
import { DisplaySIPCards } from "./SipTransactions";
import { InvestorTableCardActive } from "./SipTransactions";

export class FmpTransactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fmpvalues: { totalFMPs: "", totalvalueofFMPS: "" },
    };
  }
  async componentDidMount() {
    const params = {
      agentcode: this.props.token,
    };
    const response = await this.props.getFMPdata(params);
    const data = !!response.DtData[0] ? response.DtData[0] : "";
    const { Total_fmp, Total_value } = data;
    this.setState({
      fmpvalues: {
        totalFMPs: !!Total_fmp ? Total_fmp : "",
        totalvalueofFMPS: !!Total_value ? Total_value : "",
      },
    });
  }
  render() {
    return (
      <div className="transaction_sec">
        <div
          className="simple-card-div fmp_simple_card_sec"
          style={{ flexWrap: "wrap" }}
        >
          <DisplaySIPCards
            name="Total FMPs"
            count={
              !!this.state.fmpvalues.totalFMPs
                ? this.state.fmpvalues.totalFMPs
                : "0"
            }
            Image={"/images/fmp_icon.png"}
          />
          <DisplaySIPCards
            name="Total Value of FMP"
            count={
              !!this.state.fmpvalues.totalvalueofFMPS
                ? this.state.fmpvalues.totalvalueofFMPS
                : "0"
            }
            currencyformat={true}
            Image={"/images/fmp_fixed_icon.png"}
          />
        </div>
        {this.props.count > 0 ? (
          <CustomLoading />
        ) : !!this.props.fmpTransactions &&
          this.props.fmpTransactions.length &&
          this.props.fmpTransactions.length >= 1 ? (
          <div>
            <Paper className="trasaction-summary-responsive">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  margin: 20,
                  marginBottom: "0px",
                }}
              />
              <Table>
                {/* <TableHead> */}
                <TableRow>
                  {fmp_columns.map((c) => (
                    <TableCell
                      key={c.key}
                      style={{
                        padding: "15px 10px 5px 15px",
                        color: "white",
                        fontSize: 15,
                        fontFamily: "OpenSans-SemiBold",
                        backgroundColor: "#007ac8",
                      }}
                    >
                      <p style={{ marginBottom: "2px" }}>{c.name}</p>
                      <p style={{ fontSize: "10px" }}>{c.subtitle}</p>
                    </TableCell>
                  ))}
                </TableRow>
                <TableBody>
                  {this.props.fmpTransactions.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell className="table-cell ">
                        {item.invname}
                      </TableCell>

                      <TableCell className="table-cell table-values">
                        {item.scheme}
                      </TableCell>
                      <TableCell className="table-cell table-values">
                        {item.acno}
                      </TableCell>
                      <TableCell className="table-cell table-values">
                        {item.MaturityDate}
                      </TableCell>
                      <TableCell className="table-cell table-values">
                        {!!item.amount ? (
                          <FormatCurrency value={item.amount} />
                        ) : (
                          0
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
            <div>
              {this.props.fmpTransactions.map((item, index) => (
                <InvestorTableCardActive
                  key={index}
                  invName={item.invname}
                  Scheme={item.scheme}
                  folio_number={item.acno}
                  Maturity_Date={item.MaturityDate}
                  amount={item.amount}
                  fmp={true}
                />
              ))}
            </div>
          </div>
        ) : (
          !!this.props.fmpTransactions &&
          this.props.fmpTransactions.length === 0 &&
          this.props.count === 0 && (
            <div className="text-center p-4">No Data Found</div>
          )
        )}
      </div>
    );
  }
}

export default connect(
  ({ authReducer, loading, transactions }) => {
    const { token } = authReducer;
    const { fmpTransactions } = transactions;
    const { count } = loading;
    return {
      token,
      count,
      fmpTransactions,
    };
  },
  {
    getFMPdata,
  }
)(FmpTransactions);
